var React = require('react');

function Compass (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#FFF","d":"M17.5 0C7.835 0 0 7.835 0 17.5S7.835 35 17.5 35 35 27.165 35 17.5 27.165 0 17.5 0zm0 32.5c-8.2837 0-15-6.7162-15-15 0-8.2837 6.7163-15 15-15 8.2838 0 15 6.7163 15 15 0 8.2838-6.7162 15-15 15z","key":0}),React.createElement("path",{"fill":"#FFF","d":"M7.7775 27.2213S18.825 23.2425 21.035 21.035c2.21-2.21 6.1863-13.2575 6.1863-13.2575S16.1737 11.7562 13.965 13.965c-2.2088 2.2087-6.1875 13.2563-6.1875 13.2563zm7.955-11.4888l3.535 3.535c.8838.8838-7.9537 4.4188-7.9537 4.4188s3.535-8.8375 4.4187-7.9538z","key":1})]);
}

Compass.defaultProps = {"width":"35","height":"35","viewBox":"0 0 35 35"};

module.exports = Compass;

Compass.default = Compass;
